module.exports = __webpack_public_path__ + "static/img/bg.f943426.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baoming2/bg.jpg
// module id = flvb
// module chunks = 1